import React from 'react';
import { Pagination } from 'react-bootstrap';
export default function Paginacion(p) {
    if (p.length === 0)
        return React.createElement(React.Fragment, null);
    var setpage = p.setpage, length = p.length, mostrar = p.mostrar, page = p.page, total_page = Math.ceil(length / mostrar), buttons = [];
    if (page === 1) {
        buttons.push(React.createElement(Pagination.Item, { key: 'active1', active: true }, "1"));
    }
    else {
        buttons.push(React.createElement(Pagination.Item, { key: 'p1', onClick: setpage.bind(p, 1) }, "1"));
    }
    for (var i = 3; i > 0; i--) {
        if (page - i > 1) {
            if (i === 3) {
                buttons.push(React.createElement(Pagination.Ellipsis, { key: 'Ellipsis1' }));
            }
            else {
                buttons.push(React.createElement(Pagination.Item, { key: 'p' + (page - i), onClick: setpage.bind(p, page - i) }, page - i));
            }
        }
    }
    if (total_page > page && page > 1) {
        buttons.push(React.createElement(Pagination.Item, { active: true }, page));
    }
    for (var i = 1; i < 4; i++) {
        if (page + i < total_page) {
            if (i === 3) {
                buttons.push(React.createElement(Pagination.Ellipsis, { key: 'Ellipsis2' }));
            }
            else {
                buttons.push(React.createElement(Pagination.Item, { key: 'p' + (page + i), onClick: setpage.bind(p, page + i) }, page + i));
            }
        }
    }
    if (page === total_page) {
        if (1 < total_page) {
            buttons.push(React.createElement(Pagination.Item, { key: 'active' + total_page, active: true }, total_page));
        }
    }
    else {
        buttons.push(React.createElement(Pagination.Item, { key: 'p' + total_page, onClick: setpage.bind(p, total_page) }, total_page));
    }
    return React.createElement(Pagination, { style: { position: 'relative', float: 'right' } }, buttons);
}
//# sourceMappingURL=Paginacion.js.map